
/**
 * Vídeo banner
 */
	window.addEventListener('load', _ => {
		const video = document.querySelector('video')
		const intro = document.querySelector('.sc--intro')
		const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

		if (video) {
			video.setAttribute('src', video.dataset.src)

			setTimeout(() => {
				video.setAttribute('playsinline', true)
				video.play()
			}, 500);

			setTimeout(() => {
				if (intro && isVideoPlaying(video)) intro.classList.add('is--playing')
			}, 750);
		}
	})


/**
 * Vídeo blog
 */
	const siteVideo = document.querySelectorAll('[site-video]')

	if (siteVideo) {
		siteVideo.forEach(e => {
			e.addEventListener('click', c => {
				c.preventDefault()

				const container = e.parentElement
				const iframe = `<iframe class="mr--i_full" src="${e.dataset.video}?autoplay=1&rel=0&controls=1&showinfo=0&muted=1" width="560" height="315" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`

				container.classList.add('is--playing')

				setTimeout(_ => {
					container.innerHTML = iframe
				}, 500);
			})
		})
	}
